import { remapImageRefUploadKeys } from './remapImageRefUploadKeys';

/**
 * `apollo-upload-client` names each multipart part `1..n` and writes the `map`
 * before it has seen a single file, so the part names it produces carry no
 * meaning. The backend needs an image's part name to be its `imageRef`, and
 * this is the last point at which the assembled body can still be corrected —
 * the library exposes no other hook past the point the `map` is written.
 *
 * A factory rather than a bare constant so a test can inject a spy in place
 * of the real `baseFetch` and observe exactly what `apollo-upload-client`'s
 * `createUploadLink` hands it.
 */
export const createUploadFetch =
  (baseFetch: typeof fetch): typeof fetch =>
  (input, init) => {
    if (!(init?.body instanceof FormData)) return baseFetch(input, init);

    return baseFetch(input, {
      ...init,
      body: remapImageRefUploadKeys(init.body),
    });
  };
